import { NavLink, ThemeIcon } from '@mantine/core';
import { IconUsers } from '@tabler/icons';
import { AppRoutePaths } from '../../../utils/enums/routes';

interface UserLinkProps {
  navigate(route: string): void;
}

export function UserLink({ navigate }: UserLinkProps) {
  return (
    <NavLink
      styles={{
        label: {
          color: '#373A40',
        },
      }}
      label="Usuários"
      fw="bold"
      color=""
      icon={
        <ThemeIcon color="blue" variant="light">
          <IconUsers size={16} />
        </ThemeIcon>
      }
      childrenOffset={28}
    >
      <NavLink
        label="Cadastro"
        onClick={() => navigate(AppRoutePaths.USERS_CREATE)}
      />
      <NavLink label="Lista" onClick={() => navigate(AppRoutePaths.USERS)} />
    </NavLink>
  );
}
